import React from 'react';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import Eyecon from '@wix/da-ds/pkg/Icons/Eye';
import useDeviationStats from './useDeviationStats';
import Stat from './Stat';
const ViewStat = ({ deviation, onlyNumbers, className })=>{
    const { views, isViewCountable } = useDeviationStats(deviation);
    return !isViewCountable ? null : /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: Eyecon,
        statNameLocaleKey: "deviation.stats.views",
        statCount: views,
        onlyNumbers: onlyNumbers,
        biData: BiData({
            evid: 2,
            click_info: 'views',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    });
};
ViewStat.displayName = 'ViewStat';
export default ViewStat;

//# sourceMappingURL=ViewStat.js.map